import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityManageHierarchy extends Layout {
    panelManageHierarchy: Panel;
    sourceHierarchy: DataSource;
    textboxDescription: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxId: Textbox;
    textboxParentId: Textbox;
}
